<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="21" viewBox="0 0 20 21">
    <g fill="none" fill-rule="evenodd" transform="translate(0 .6)">
        <path style="fill: currentColor" d="M8.682 14.773l-4.676-4.676 1.485-1.485 3.191 3.191 5.8-5.799 1.484 1.485-7.284 7.284zM9.8 0C4.396 0 0 4.396 0 9.8c0 5.404 4.396 9.8 9.8 9.8 5.404 0 9.8-4.396 9.8-9.8 0-5.404-4.396-9.8-9.8-9.8z"/>
    </g>
</svg>
